// // components/modals/CompanyDetailsModal.jsx

// import { useEffect, useState } from "react";

// import {
//   Dialog,
//   DialogContent,
//   DialogHeader,
//   DialogTitle,
//   DialogDescription,
//   DialogFooter,
// } from "@/components/ui/dialog";

// import { Button } from "@/components/ui/button";
// import {
//   Loader2,
//   CheckCircle2,
//   User,
//   Layers3,
//   ClipboardList,
//   ChevronDown,
// } from "lucide-react";
// import { useDispatch } from "react-redux";
// import {
//   GetCompanyRequestDetail,
//   GetMasterCompanyDetail,
// } from "@/services/api/company.service";
// import { callLoader } from "@/redux/Loader/actions";
// import { showToast } from "@/redux/Toast/actions";
// import { formatDisplayDateTime } from "@/utils/dateUtils";
// import SectionDivider from "@/components/common/SectionDivider";
// import FormLabel from "@/components/common/FormLabel";
// import { useParams } from "react-router-dom";

// const InfoItem = ({ label, value }) => (
//   <div className="space-y-1.5">
//     <FormLabel>{label}</FormLabel>
//     <div className="min-h-[38px] rounded-lg border border-slate-600 dark:border-slate-700/60 bg-slate-50 dark:bg-slate-800/40 px-3 py-2 text-sm text-slate-800 dark:text-slate-200 break-words flex items-center">
//       {value || <span className="text-slate-300 dark:text-slate-600">—</span>}
//     </div>
//   </div>
// );

// const SummaryCard = ({ label, value, accent }) => (
//   <div className="flex flex-col gap-1 rounded-xl bg-slate-50 dark:bg-slate-800/50 border border-slate-100 dark:border-slate-700/50 px-4 py-3">
//     <p className="text-[10px] font-semibold uppercase tracking-widest text-slate-900 dark:text-slate-500">
//       {label}
//     </p>
//     <p
//       className={`text-xl font-semibold ${accent ? "text-emerald-600 dark:text-emerald-400" : "text-slate-800 dark:text-slate-100"}`}
//     >
//       {value}
//     </p>
//   </div>
// );

// const CollapsibleSection = ({
//   title,
//   icon: Icon,
//   color = "blue",
//   defaultOpen = true,
//   children,
// }) => {
//   const [open, setOpen] = useState(defaultOpen);

//   const colors = {
//     blue: "bg-blue-500",
//     green: "bg-emerald-500",
//     purple: "bg-purple-500",
//     amber: "bg-amber-500",
//     red: "bg-red-500",
//   };

//   return (
//     <section className="rounded-2xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 overflow-hidden">
//       {/* HEADER */}
//       <button
//         type="button"
//         onClick={() => setOpen(!open)}
//         className="w-full flex items-center justify-between px-4 py-3 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors"
//       >
//         <div className="flex items-center gap-3">
//           <div
//             className={`w-8 h-8 rounded-lg flex items-center justify-center ${colors[color]}`}
//           >
//             <Icon className="w-4 h-4 text-white" />
//           </div>

//           <h3 className="text-sm font-semibold text-slate-900 dark:text-white">
//             {title}
//           </h3>
//         </div>

//         <ChevronDown
//           className={`w-4 h-4 text-slate-500 transition-transform ${
//             open ? "rotate-180" : ""
//           }`}
//         />
//       </button>

//       {/* CONTENT */}
//       {open && (
//         <div className="p-4 border-t border-slate-200 dark:border-slate-700">
//           {children}
//         </div>
//       )}
//     </section>
//   );
// };

// export default function CompanyDetailsModal({
//   open,
//   onOpenChange,
//   companyId,
//   onApprove,
//   isMaster = false,
// }) {
//   const dispatch = useDispatch();

//   const [loading, setLoading] = useState(false);
//   const [company, setCompany] = useState(null);

//   useEffect(() => {
//     if (!open || !companyId) return;

//     const controller = new AbortController();

//     const fetchCompanyDetails = async () => {
//       try {
//         setLoading(true);
//         dispatch(callLoader(true));

//         const response = isMaster
//           ? await GetMasterCompanyDetail(companyId, controller.signal)
//           : await GetCompanyRequestDetail(companyId, controller.signal);

//         setCompany(response);
//       } catch (error) {
//         // 👇 ignore abort errors
//         if (error.name === "AbortError") return;

//         console.error(error);

//         dispatch(
//           showToast(
//             error?.response?.data?.message ||
//               error?.message ||
//               "Failed to fetch company details",
//             "error",
//             true,
//           ),
//         );
//       } finally {
//         setLoading(false);
//         dispatch(callLoader(false));
//       }
//     };

//     fetchCompanyDetails();

//     return () => {
//       controller.abort(); // ✅ kills request
//       dispatch(callLoader(false)); // ✅ force cleanup
//     };
//   }, [open, companyId]);

//   // Compute subscription totals
//   const totalBaseModules = company?.subscribedBaseModuleDetails?.length ?? 0;

//   const totalSeats =
//     company?.subscribedBaseModuleDetails?.reduce(
//       (sum, m) => sum + (m.seats || 0),
//       0,
//     ) ?? 0;

//   const totalValue =
//     company?.subscribedBaseModuleDetails?.reduce(
//       (sum, m) => sum + (m.customPrice || 0),
//       0,
//     ) ?? 0;

//   const hasLogo =
//     company?.companyLogo && company.companyLogo !== "https://api.shipez.ai/";

//   return (
//     <Dialog open={open} onOpenChange={onOpenChange}>
//       <DialogContent className="max-w-4xl p-0 overflow-hidden border-slate-200 dark:border-slate-700 rounded-2xl shadow-xl">
//         {/* ── HEADER ── */}
//         <DialogHeader className="px-6 py-5 border-b border-slate-100 dark:border-slate-700/60">
//           <div className="flex items-center justify-between gap-4">
//             <div className="flex items-center gap-4">
//               {/* Company avatar / logo */}
//               <div className="w-12 h-12 rounded-xl overflow-hidden border border-slate-200 dark:border-slate-700 flex-shrink-0 flex items-center justify-center bg-slate-100 dark:bg-slate-800">
//                 {hasLogo ? (
//                   <img
//                     src={company.companyLogo}
//                     alt={company.companyName}
//                     className="w-full h-full object-cover"
//                   />
//                 ) : (
//                   <div className="w-full h-full bg-gradient-to-br from-teal-500 to-cyan-500 flex items-center justify-center text-white font-bold text-lg">
//                     {company?.companyName?.charAt(0) || "C"}
//                   </div>
//                 )}
//               </div>

//               <div>
//                 <div className="flex items-center gap-2">
//                   <DialogTitle className="text-base font-semibold text-slate-900 dark:text-white leading-tight">
//                     {company?.companyName || "Company Details"}
//                   </DialogTitle>

//                   {company && (
//                     <span
//                       className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-semibold ${
//                         company.isActive
//                           ? "bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400"
//                           : "bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400"
//                       }`}
//                     >
//                       {company.isActive ? "Active" : "Inactive"}
//                     </span>
//                   )}
//                 </div>

//                 <DialogDescription className="text-xs text-slate-900 dark:text-slate-500 mt-0.5">
//                   {[
//                     company?.profileCategory,
//                     company?.profileUserName
//                       ? `@${company.profileUserName}`
//                       : null,
//                   ]
//                     .filter(Boolean)
//                     .join(" · ") || "Review company signup request"}
//                 </DialogDescription>
//               </div>
//             </div>
//           </div>
//         </DialogHeader>

//         {loading ? (
//           <div className="h-[400px] flex items-center justify-center">
//             <Loader2 className="w-5 h-5 animate-spin text-slate-400" />
//           </div>
//         ) : (
//           <>
//             <div className="p-6 space-y-7 max-h-[72vh] overflow-y-auto">
//               {/* ── ADMIN INFO ── */}
//               <CollapsibleSection
//                 title="Admin Information"
//                 icon={User}
//                 color="blue"
//               >
//                 <div className="grid md:grid-cols-2 gap-3">
//                   <InfoItem
//                     label="Admin Name"
//                     value={`${company?.profileFirstName || ""} ${company?.profileLastName || ""}`.trim()}
//                   />
//                   <InfoItem
//                     label="Username"
//                     value={
//                       company?.profileUserName
//                         ? `@${company.profileUserName}`
//                         : undefined
//                     }
//                   />
//                   <InfoItem label="Email" value={company?.profileEmailId} />
//                   <InfoItem label="Phone" value={company?.profilePhone} />
//                   <InfoItem label="Country" value={company?.profileCountry} />
//                   <InfoItem
//                     label="Region / State"
//                     value={company?.profileRegion}
//                   />
//                   <InfoItem label="City" value={company?.profileCity} />
//                   <InfoItem label="Zip Code" value={company?.profileZipCode} />
//                   <InfoItem
//                     label="Address Line 1"
//                     value={company?.profileAddress1}
//                   />
//                   <InfoItem
//                     label="Address Line 2"
//                     value={company?.profileAddress2}
//                   />
//                   <InfoItem
//                     label="Full Address"
//                     value={company?.profileAddressPrint}
//                   />
//                   <InfoItem label="Created By" value={company?.createdBy} />
//                   <InfoItem
//                     label="Created On"
//                     value={
//                       company?.createdOn
//                         ? formatDisplayDateTime(company.createdOn)
//                         : undefined
//                     }
//                   />
//                   <InfoItem label="Modified By" value={company?.modifiedBy} />
//                   <InfoItem
//                     label="Modified On"
//                     value={
//                       company?.modifiedOn
//                         ? formatDisplayDateTime(company.modifiedOn)
//                         : undefined
//                     }
//                   />
//                 </div>
//               </CollapsibleSection>

//               {/* ── SUBSCRIPTION SUMMARY ── */}
//               {totalBaseModules > 0 && (
//                 <CollapsibleSection
//                   icon={ClipboardList}
//                   title="Subscription summary"
//                   color="purple"
//                 >
//                   <div className="grid grid-cols-3 gap-3">
//                     <SummaryCard
//                       label="Base modules"
//                       value={totalBaseModules}
//                     />
//                     <SummaryCard
//                       label="Total seats"
//                       value={totalSeats.toLocaleString()}
//                     />
//                     <SummaryCard
//                       label="Total value"
//                       value={`₹${totalValue.toLocaleString("en-IN")}`}
//                       accent
//                     />
//                   </div>
//                 </CollapsibleSection>
//               )}

//               {/* ── SUBSCRIBED MODULES ── */}
//               {totalBaseModules > 0 && (
//                 <CollapsibleSection
//                   icon={Layers3}
//                   title="Subscribed Modules"
//                   color="teal"
//                 >
//                   <div className="space-y-3">
//                     {company.subscribedBaseModuleDetails.map((baseModule) => {
//                       // Per-base-module total
//                       const baseModuleTotal =
//                         baseModule.subscribedModuleDetails?.reduce(
//                           (sum, m) => sum + (m.customPrice || 0),
//                           0,
//                         ) ??
//                         baseModule.customPrice ??
//                         0;

//                       return (
//                         <div
//                           key={baseModule.id}
//                           className="rounded-xl border border-slate-200 dark:border-slate-700/60 overflow-hidden"
//                         >
//                           {/* Base module header */}
//                           <div className="flex items-start justify-between px-5 py-4 bg-slate-50 dark:bg-slate-800/50 border-b border-slate-100 dark:border-slate-700/50">
//                             <div>
//                               <h3 className="text-sm font-semibold text-slate-900 dark:text-white">
//                                 {baseModule.baseModuleName}
//                               </h3>
//                               <p className="text-xs text-slate-400 dark:text-slate-500 mt-0.5">
//                                 {baseModule.baseModuleDescription ||
//                                   "No description available"}
//                               </p>
//                             </div>

//                             <div className="flex flex-col items-end gap-1.5 ml-4 flex-shrink-0">
//                               <span className="text-[11px] font-medium px-2.5 py-0.5 rounded-full bg-white dark:bg-slate-700 border border-slate-200 dark:border-slate-600 text-slate-500 dark:text-slate-300">
//                                 {baseModule.seats} seats
//                               </span>
//                               <span className="text-sm font-semibold text-emerald-600 dark:text-emerald-400">
//                                 ₹{baseModuleTotal.toLocaleString("en-IN")}
//                               </span>
//                             </div>
//                           </div>

//                           {/* Modules */}
//                           <div className="p-4 space-y-2.5 bg-white dark:bg-slate-900">
//                             {baseModule.subscribedModuleDetails?.length > 0 ? (
//                               baseModule.subscribedModuleDetails.map(
//                                 (module) => (
//                                   <div
//                                     key={module.id}
//                                     className="rounded-lg border border-slate-100 dark:border-slate-700/50 bg-slate-50 dark:bg-slate-800/30 px-4 py-3"
//                                   >
//                                     {/* Module header */}
//                                     <div className="flex items-center justify-between">
//                                       <div>
//                                         <p className="text-sm font-medium text-slate-800 dark:text-slate-100">
//                                           {module.moduleName}
//                                         </p>
//                                         <p className="text-xs text-slate-400 dark:text-slate-500 mt-0.5">
//                                           {module.seats} seats
//                                         </p>
//                                       </div>
//                                       <span className="text-sm font-semibold text-emerald-600 dark:text-emerald-400">
//                                         ₹
//                                         {(
//                                           module.customPrice || 0
//                                         ).toLocaleString("en-IN")}
//                                       </span>
//                                     </div>

//                                     {/* Sub-modules */}
//                                     {module.subscribedSubModuleDetails?.length >
//                                       0 && (
//                                       <div className="mt-2.5 flex flex-wrap gap-1.5">
//                                         {module.subscribedSubModuleDetails.map(
//                                           (subModule) => (
//                                             <span
//                                               key={subModule.id}
//                                               className="px-2.5 py-0.5 rounded-full text-[11px] font-medium bg-blue-50 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300"
//                                             >
//                                               {subModule.subModuleName}
//                                             </span>
//                                           ),
//                                         )}
//                                       </div>
//                                     )}
//                                   </div>
//                                 ),
//                               )
//                             ) : (
//                               <p className="text-xs text-slate-400 dark:text-slate-500 py-1">
//                                 No modules subscribed
//                               </p>
//                             )}

//                             {/* Per-base-module subtotal row */}
//                             {baseModule.subscribedModuleDetails?.length > 0 && (
//                               <div className="flex justify-end pt-1 border-t border-slate-100 dark:border-slate-700/40 mt-1">
//                                 <p className="text-xs text-slate-400 dark:text-slate-500">
//                                   Subtotal:{" "}
//                                   <span className="font-semibold text-emerald-600 dark:text-emerald-400">
//                                     ₹{baseModuleTotal.toLocaleString("en-IN")}
//                                   </span>
//                                 </p>
//                               </div>
//                             )}
//                           </div>
//                         </div>
//                       );
//                     })}
//                   </div>
//                 </CollapsibleSection>
//               )}
//             </div>

//             {/* ── FOOTER ── */}
//             <DialogFooter className="px-6 py-4 border-t border-slate-100 dark:border-slate-700/60 bg-slate-50 dark:bg-slate-800/30">
//               <Button
//                 variant="outline"
//                 onClick={() => onOpenChange(false)}
//                 className="text-sm"
//               >
//                 Close
//               </Button>

//               <Button
//                 onClick={() => onApprove(company)}
//                 className="bg-emerald-500 hover:bg-emerald-600 text-white text-sm gap-1.5"
//               >
//                 <CheckCircle2 className="w-4 h-4" />
//                 Approve company
//               </Button>
//             </DialogFooter>
//           </>
//         )}
//       </DialogContent>
//     </Dialog>
//   );
// }
// pages/company/CompanyDetailsPage.jsx

import { useEffect, useState } from "react";

import {
  Loader2,
  CheckCircle2,
  User,
  Layers3,
  ClipboardList,
  ChevronDown,
  ArrowLeft,
} from "lucide-react";

import { Button } from "@/components/ui/button";

import { useDispatch } from "react-redux";

import {
  GetCompanyRequestDetail,
  GetMasterCompanyDetail,
} from "@/services/api/company.service";

import { callLoader } from "@/redux/Loader/actions";
import { showToast } from "@/redux/Toast/actions";

import { formatDisplayDateTime } from "@/utils/dateUtils";

import FormLabel from "@/components/common/FormLabel";

import { useLocation, useNavigate, useParams } from "react-router-dom";
import { calculateTotal } from "@/components/CompanySetup/moduleSelectionHelpers";

const InfoItem = ({ label, value, valueClassName = "", className = "" }) => (
  <div className={`space-y-1.5 ${className}`}>
    <FormLabel className="text-[11px] sm:text-xs">{label}</FormLabel>

    <div
      className={`min-h-[42px] rounded-lg border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/40 px-3 py-2 text-sm text-slate-800 dark:text-slate-200 break-words flex items-center leading-relaxed ${valueClassName}`}
    >
      {value || <span className="text-slate-300 dark:text-slate-600">—</span>}
    </div>
  </div>
);

const SummaryCard = ({ label, value, accent }) => (
  <div className="flex flex-col gap-1 rounded-xl bg-slate-50 dark:bg-slate-800/50 border border-slate-200 dark:border-slate-700 px-4 py-3">
    <p className="text-[10px] font-semibold uppercase tracking-widest text-slate-500 dark:text-slate-400">
      {label}
    </p>

    <p
      className={`text-lg sm:text-xl font-semibold break-words ${
        accent
          ? "text-emerald-600 dark:text-emerald-400"
          : "text-slate-800 dark:text-slate-100"
      }`}
    >
      {value}
    </p>
  </div>
);

const CollapsibleSection = ({
  title,
  icon: Icon,
  color = "blue",
  defaultOpen = true,
  children,
}) => {
  const [open, setOpen] = useState(defaultOpen);

  const colors = {
    blue: "bg-blue-500",
    green: "bg-emerald-500",
    purple: "bg-purple-500",
    amber: "bg-amber-500",
    red: "bg-red-500",
    teal: "bg-teal-500",
  };

  return (
    <section className="overflow-hidden rounded-2xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 shadow-sm">
      {/* HEADER */}
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between gap-3 px-4 py-3 text-left transition-colors hover:bg-slate-50 dark:hover:bg-slate-800"
      >
        <div className="flex items-center gap-3 min-w-0">
          <div
            className={`flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-xl ${colors[color]}`}
          >
            <Icon className="h-4 w-4 text-white" />
          </div>

          <h3 className="truncate text-sm sm:text-base font-semibold text-slate-900 dark:text-white">
            {title}
          </h3>
        </div>

        <ChevronDown
          className={`h-4 w-4 flex-shrink-0 text-slate-500 transition-transform duration-200 ${
            open ? "rotate-180" : ""
          }`}
        />
      </button>

      {/* CONTENT */}
      {open && (
        <div className="border-t border-slate-200 dark:border-slate-700 p-4 sm:p-5">
          {children}
        </div>
      )}
    </section>
  );
};

const CompanyDetailsModal = ({ onApprove }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const isMaster = location?.state?.isMaster ?? false;

  const { companyId } = useParams();

  const [loading, setLoading] = useState(false);

  const [company, setCompany] = useState(null);
  console.log("company: ", company);

  useEffect(() => {
    if (!companyId) return;

    const controller = new AbortController();

    const fetchCompanyDetails = async () => {
      try {
        setLoading(true);

        dispatch(callLoader(true));

        const response = isMaster
          ? await GetMasterCompanyDetail(companyId, controller.signal)
          : await GetCompanyRequestDetail(companyId, controller.signal);

        setCompany(response);
        console.log("response: ", response);
      } catch (error) {
        if (error.name === "AbortError") return;

        console.error(error);

        dispatch(
          showToast(
            error?.response?.data?.message ||
              error?.message ||
              "Failed to fetch company details",
            "error",
            true,
          ),
        );
      } finally {
        setLoading(false);

        dispatch(callLoader(false));
      }
    };

    fetchCompanyDetails();

    return () => {
      controller.abort();

      dispatch(callLoader(false));
    };
  }, [companyId]);

  // SUMMARY
  const totalBaseModules = company?.SUBSCRIBED_BASEMODULE_DETAILS?.length ?? 0;

  const totalSeats =
    company?.SUBSCRIBED_BASEMODULE_DETAILS?.reduce(
      (sum, m) => sum + (m.SEATS || 0),
      0,
    ) ?? 0;

  const totalValue =
    company?.SUBSCRIBED_BASEMODULE_DETAILS?.reduce(
      (sum, m) => sum + (m.CUSTOM_PRICE || 0),
      0,
    ) ?? 0;

  const hasLogo =
    company?.COMPANYLOGO && company.COMPANYLOGO !== "https://api.shipez.ai/";

  return (
    <div className="w-full min-h-screen bg-slate-100 dark:bg-slate-900">
      {/* HEADER */}
      <div className="bg-white dark:bg-slate-900 border-b border-slate-200 dark:border-slate-700 px-4 sm:px-6 py-4 sm:py-5">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
          {/* LEFT SECTION */}
          <div className="flex items-start sm:items-center gap-3 sm:gap-4 min-w-0">
            {/* BACK BUTTON */}
            <button
              onClick={() => navigate("/admin/companies")}
              className="w-10 h-10 rounded-xl border border-slate-200 dark:border-slate-700 flex items-center justify-center hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors flex-shrink-0"
            >
              <ArrowLeft className="w-5 h-5 text-slate-700 dark:text-slate-300" />
            </button>

            {/* LOGO */}
            <div className="w-11 h-11 sm:w-12 sm:h-12 rounded-xl overflow-hidden border border-slate-200 dark:border-slate-700 flex-shrink-0 flex items-center justify-center bg-slate-100 dark:bg-slate-800">
              {hasLogo ? (
                <img
                  src={company.COMPANYLOGO}
                  alt={company.COMPANYNAME}
                  className="w-full h-full object-cover"
                />
              ) : (
                <div className="w-full h-full bg-gradient-to-br from-teal-500 to-cyan-500 flex items-center justify-center text-white font-bold text-base sm:text-lg">
                  {company?.COMPANYNAME?.charAt(0) || "C"}
                </div>
              )}
            </div>

            {/* COMPANY INFO */}
            <div className="min-w-0 flex-1">
              <div className="flex flex-wrap items-center gap-2">
                <h1 className="text-base sm:text-lg font-semibold text-slate-900 dark:text-white break-words">
                  {company?.COMPANYNAME || "Company Details"}
                </h1>

                {company && (
                  <span
                    className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-semibold whitespace-nowrap ${
                      company.isActive
                        ? "bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400"
                        : "bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400"
                    }`}
                  >
                    {company.isActive ? "Active" : "Inactive"}
                  </span>
                )}
              </div>

              <p className="text-xs text-slate-500 dark:text-slate-400 mt-1 break-words">
                {[
                  company?.PROFILE_CATEGORY,
                  company?.PROFILE_USERNAME
                    ? `@${company.PROFILE_USERNAME}`
                    : null,
                ]
                  .filter(Boolean)
                  .join(" · ") || "Review company signup request"}
              </p>
            </div>
          </div>

          {/* ACTION BUTTON */}
          {onApprove && (
            <div className="w-full sm:w-auto">
              <Button
                onClick={() => onApprove(company)}
                className="w-full sm:w-auto bg-emerald-500 hover:bg-emerald-600 text-white text-sm gap-1.5"
              >
                <CheckCircle2 className="w-4 h-4" />
                Approve company
              </Button>
            </div>
          )}
        </div>
      </div>

      {/* CONTENT */}
      {loading ? (
        <div className="h-[400px] flex items-center justify-center">
          <Loader2 className="w-5 h-5 animate-spin text-slate-400" />
        </div>
      ) : (
        <div className="p-6 space-y-7">
          {/* ADMIN INFO */}
          <CollapsibleSection
            title="Admin Information"
            icon={User}
            color="blue"
          >
            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
              {/* COMPANY */}
              <InfoItem label="Company Name" value={company?.COMPANYNAME} />

              <InfoItem
                label="Company Category"
                value={company?.PROFILE_CATEGORY}
              />

              <InfoItem label="Powered By" value={company?.POWERED_BY} />

              <InfoItem
                label="License Number"
                value={company?.LICENCE_NUMBER}
              />

              {/* ADMIN */}
              <InfoItem
                label="Admin Name"
                value={`${company?.PROFILE_FIRSTNAME || ""} ${
                  company?.PROFILE_LASTNAME || ""
                }`.trim()}
              />

              <InfoItem
                label="Username"
                value={
                  company?.PROFILE_USERNAME
                    ? `@${company.PROFILE_USERNAME}`
                    : undefined
                }
              />

              <InfoItem label="Email" value={company?.PROFILE_EMAILID} />

              <InfoItem label="Phone" value={company?.PROFILE_PHONE} />

              {/* LOCATION */}
              <InfoItem label="Country" value={company?.PROFILE_COUNTRY} />

              <InfoItem
                label="Region / State"
                value={company?.PROFILE_REGION}
              />

              <InfoItem label="City" value={company?.PROFILE_CITY} />

              <InfoItem label="Zip Code" value={company?.PROFILE_ZIPCODE} />

              {/* FULL WIDTH ADDRESS */}
              <div className="sm:col-span-2 xl:col-span-3">
                <InfoItem
                  label="Address Line 1"
                  value={company?.PROFILE_ADDRESS1}
                />
              </div>

              <div className="sm:col-span-2 xl:col-span-3">
                <InfoItem
                  label="Address Line 2"
                  value={company?.PROFILE_ADDRESS2}
                />
              </div>

              <div className="sm:col-span-2 xl:col-span-3">
                <InfoItem
                  label="Full Address"
                  value={company?.PROFILE_ADDRESSPRINT}
                />
              </div>

              {/* SYSTEM */}
              <InfoItem label="Company ID" value={company?.COMPANYID} />

              <InfoItem label="Role ID" value={company?.ROLEID} />

              <InfoItem
                label="Account Status"
                value={company?.ISACTIVE ? "Active" : "Inactive"}
                valueClassName={
                  company?.ISACTIVE
                    ? "text-emerald-600 dark:text-emerald-400"
                    : "text-red-600 dark:text-red-400"
                }
              />

              <InfoItem
                label="Confirmation Status"
                value={
                  company?.ISCONFIRMED
                    ? "Confirmed"
                    : company?.ISDECLINED
                      ? "Declined"
                      : "Pending"
                }
              />

              {/* AUDIT */}
              <InfoItem label="Created By" value={company?.CREATED_BY} />

              <InfoItem
                label="Created On"
                value={
                  company?.CREATED_ON
                    ? formatDisplayDateTime(company.CREATED_ON)
                    : undefined
                }
              />

              <InfoItem label="Modified By" value={company?.MODIFIED_BY} />

              <InfoItem
                label="Modified On"
                value={
                  company?.MODIFIED_ON
                    ? formatDisplayDateTime(company.MODIFIED_ON)
                    : undefined
                }
              />

              <InfoItem label="Deleted By" value={company?.DELETED_BY} />

              <InfoItem
                label="Deleted On"
                value={
                  company?.DELETED_ON
                    ? formatDisplayDateTime(company.DELETED_ON)
                    : undefined
                }
              />
            </div>
          </CollapsibleSection>

          {/* SUBSCRIPTION SUMMARY */}
          {totalBaseModules > 0 && (
            <CollapsibleSection
              icon={ClipboardList}
              title="Subscription Summary"
              color="purple"
            >
              <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
                <SummaryCard label="Base Modules" value={totalBaseModules} />

                <SummaryCard
                  label="Total Seats"
                  value={totalSeats.toLocaleString()}
                />

                <SummaryCard
                  label="Total Value"
                  value={`₹${calculateTotal(
                    company?.SUBSCRIBED_BASEMODULE_DETAILS,
                  ).toLocaleString("en-IN")}`}
                  accent
                />
              </div>
            </CollapsibleSection>
          )}

          {/* SUBSCRIBED MODULES */}
          {totalBaseModules > 0 && (
            <CollapsibleSection
              icon={Layers3}
              title="Subscribed Modules"
              color="teal"
            >
              <div className="space-y-4 sm:space-y-5">
                {company.SUBSCRIBED_BASEMODULE_DETAILS.map((baseModule) => {
                  const subscribedModules =
                    baseModule.SUBSCRIBED_MODULE_DETAILS || [];

                  const hasModules = subscribedModules.length > 0;

                  // TOTAL = BASE PRICE + SUBMODULES
                  const totalSubmodulePrice = subscribedModules.reduce(
                    (moduleSum, module) => {
                      const submoduleTotal =
                        module.SUBSCRIBED_SUBMODULE_DETAILS?.reduce(
                          (subSum, subModule) =>
                            subSum + (subModule.CUSTOM_PRICE || 0),
                          0,
                        ) || 0;

                      return moduleSum + submoduleTotal;
                    },
                    0,
                  );

                  const baseModuleTotal =
                    (baseModule.CUSTOM_PRICE || 0) + totalSubmodulePrice;

                  return (
                    <div
                      key={baseModule.ID}
                      className="overflow-hidden rounded-2xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 shadow-sm"
                    >
                      {/* HEADER */}
                      <div className="relative overflow-hidden border-b border-slate-200 dark:border-slate-700 bg-gradient-to-r from-slate-50 to-slate-100 dark:from-slate-800 dark:to-slate-900 p-4 sm:p-5">
                        <div className="absolute top-0 right-0 h-32 w-32 rounded-full bg-teal-500/5 blur-3xl" />

                        <div className="relative flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
                          {/* LEFT */}
                          <div className="space-y-3 min-w-0 flex-1">
                            <div className="flex flex-wrap items-center gap-2">
                              <h3 className="text-sm sm:text-base font-semibold text-slate-900 dark:text-white break-words">
                                {baseModule.BASEMODULE_NAME}
                              </h3>

                              <span
                                className={`rounded-full px-2.5 py-1 text-[10px] font-semibold tracking-wide ${
                                  baseModule.BASEMODULE_TYPE === "CORE"
                                    ? "bg-violet-100 text-violet-700 dark:bg-violet-900/30 dark:text-violet-300"
                                    : "bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300"
                                }`}
                              >
                                {baseModule.BASEMODULE_TYPE || "MODULE"}
                              </span>
                            </div>

                            {baseModule.BASEMODULE_DESCRIPTION && (
                              <p className="text-xs sm:text-sm leading-relaxed text-slate-500 dark:text-slate-400 break-words">
                                {baseModule.BASEMODULE_DESCRIPTION}
                              </p>
                            )}

                            <div className="flex flex-wrap items-center gap-2">
                              <span className="rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 px-2.5 py-1 text-[11px] sm:text-xs font-medium text-slate-600 dark:text-slate-300">
                                {baseModule.SEATS} Seats
                              </span>

                              {baseModule.BASEMODULE_BASEPRICETYPE && (
                                <span className="rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 px-2.5 py-1 text-[11px] sm:text-xs font-medium text-slate-600 dark:text-slate-300">
                                  {baseModule.BASEMODULE_BASEPRICETYPE}
                                </span>
                              )}

                              {hasModules && (
                                <span className="rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 px-2.5 py-1 text-[11px] sm:text-xs font-medium text-slate-600 dark:text-slate-300">
                                  {subscribedModules.length} Modules
                                </span>
                              )}
                            </div>
                          </div>

                          {/* RIGHT */}
                          <div className="w-full sm:w-auto sm:min-w-[160px] rounded-2xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 px-4 py-3 shadow-sm">
                            <p className="text-[10px] sm:text-[11px] uppercase tracking-widest text-slate-400 dark:text-slate-500 font-semibold">
                              Total Price
                            </p>

                            <p className="mt-1 text-xl sm:text-2xl font-bold text-emerald-600 dark:text-emerald-400 break-words">
                              ₹{baseModuleTotal.toLocaleString("en-IN")}
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* MODULES */}
                      {hasModules && (
                        <div className="bg-slate-50/50 dark:bg-slate-950/30 p-4 sm:p-5">
                          <div className="space-y-3 sm:space-y-4">
                            {subscribedModules.map((module) => (
                              <div
                                key={module.ID}
                                className="rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 p-4"
                              >
                                {/* MODULE HEADER */}
                                <div className="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
                                  <div className="min-w-0">
                                    <h4 className="text-sm font-semibold text-slate-900 dark:text-white break-words">
                                      {module.MODULE_NAME}
                                    </h4>

                                    {module.MODULE_DESCRIPTION && (
                                      <p className="mt-1 text-xs leading-relaxed text-slate-500 dark:text-slate-400 break-words">
                                        {module.MODULE_DESCRIPTION}
                                      </p>
                                    )}
                                  </div>

                                  <div className="flex flex-wrap items-center gap-2 text-[11px] text-slate-400 dark:text-slate-500">
                                    <span>{module.SEATS} Seats</span>

                                    {module.SUBSCRIBED_SUBMODULE_DETAILS
                                      ?.length > 0 && (
                                      <>
                                        <span>•</span>

                                        <span>
                                          {
                                            module.SUBSCRIBED_SUBMODULE_DETAILS
                                              .length
                                          }{" "}
                                          Submodules
                                        </span>
                                      </>
                                    )}
                                  </div>
                                </div>

                                {/* SUBMODULES */}
                                {module.SUBSCRIBED_SUBMODULE_DETAILS?.length >
                                  0 && (
                                  <div className="mt-4 border-l border-slate-200 dark:border-slate-700 pl-3">
                                    <div className="grid grid-cols-1 md:grid-cols-6 gap-2">
                                      {module.SUBSCRIBED_SUBMODULE_DETAILS.map(
                                        (subModule) => (
                                          <div
                                            key={subModule.ID}
                                            className="
              flex items-center justify-between gap-3
              rounded-lg border border-slate-200 dark:border-slate-700
              bg-slate-50 dark:bg-slate-900
              px-3 py-2
              min-w-0
            "
                                          >
                                            {/* LEFT */}
                                            <div className="flex items-center gap-2 min-w-0 flex-1">
                                              <div className="h-2 w-2 rounded-full bg-emerald-500 flex-shrink-0" />

                                              <div className="min-w-0">
                                                <p className="truncate text-sm font-medium text-slate-800 dark:text-slate-100">
                                                  {subModule.SUBMODULE_NAME}
                                                </p>

                                                <p className="text-[11px] text-slate-400 dark:text-slate-500">
                                                  {subModule.SEATS} Seats
                                                </p>
                                              </div>
                                            </div>

                                            {/* RIGHT */}
                                            <div className="flex-shrink-0 border-l border-slate-200 dark:border-slate-700 pl-3 text-right">
                                              <p className="whitespace-nowrap text-sm font-semibold text-emerald-600 dark:text-emerald-400">
                                                ₹
                                                {(
                                                  subModule.CUSTOM_PRICE || 0
                                                ).toLocaleString("en-IN")}
                                              </p>

                                              <p className="whitespace-nowrap text-[10px] text-slate-400 dark:text-slate-500">
                                                {subModule.SUBMODULE_BASEPRICETYPE ||
                                                  "PER MONTH"}
                                              </p>
                                            </div>
                                          </div>
                                        ),
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </CollapsibleSection>
          )}
        </div>
      )}
    </div>
  );
};

export default CompanyDetailsModal;
